import { REGISTER_SUCCESS, REGISTER_FAIL, LOAD_USER, AUTH_FAILED, LOGIN_SUCCESS, LOGIN_FAIL, LOG_OUT, ADD_AMOUNT_SUCCESS, ADD_AMOUNT_FAIL, SET_FUTURE_ESTIMATE_SUCCESS, SET_FUTURE_ESTIMATE_FAIL } from "../Actions/types";

const initialState = {
    token: localStorage.getItem('token'),
    isAuthenticated: null,     //To set user paths and show things only logged in users can see 
    loading: true,
    user: null //to get user data from backend
}

export default function (state = initialState, action) {
    const { type, payload } = action
    switch (type) {
        case LOAD_USER:
            return {
                ...state,
                isAuthenticated: true,
                loading: false,
                user: payload
            }
        case REGISTER_SUCCESS:
            {
                //localStorage.setItem('token', payload.token)
                return {
                    ...state,
                    ...payload,
                    isAuthenticated: false,
                    loading: true
                }
            }
        case AUTH_FAILED:
            {
                localStorage.removeItem('token')
                localStorage.removeItem('guestToken')
                return {
                    ...state,
                    token: null,
                    isAuthenticated: false,
                    loading: false
                }
            }
        case REGISTER_FAIL:
            {
                localStorage.removeItem('token')
                localStorage.removeItem('guestToken')
                return {
                    ...state,
                    token: null,
                    isAuthenticated: false,
                    loading: false
                }
            }
        case LOGIN_SUCCESS:
            {
                localStorage.setItem('token', payload.token)
                return {
                    ...state,
                    ...payload,
                    isAuthenticated: true,
                    loading: false
                }
            }
        case LOGIN_FAIL:
            {
                localStorage.removeItem('token')
                localStorage.removeItem('guestToken')
                return {
                    ...state,
                    token: null,
                    isAuthenticated: false,
                    loading: false,
                    user: null
                }
            }
        case LOG_OUT:
            {
                localStorage.removeItem('token');
                localStorage.removeItem('guestToken');
                localStorage.removeItem('selectedLocation');
                localStorage.removeItem('nearByLocation');
                return {
                    ...state,
                    token: null,
                    isAuthenticated: false,
                    loading: false,
                    user: null
                }
            }
        case ADD_AMOUNT_SUCCESS:
            // console.log(...state);
            return {
                ...state,
                coins: state.user.wallet.coins+payload.amount,
                // user: {
                    
                //     ...state.user.wallet,
                //     coins: payload.amount   // Assuming the payload contains the updated wallet
                // },
                loading: false
            }  
        
        case ADD_AMOUNT_FAIL:
            return {
                ...state,
                loading: false
            }
        case SET_FUTURE_ESTIMATE_SUCCESS:
            return {
                ...state, 
                futureEstimate: payload
            }
        case SET_FUTURE_ESTIMATE_FAIL:
            return {
                ...state, 
                loading: false
            }
        default:
            return state
    }

}